import { render } from "./Countdown.vue?vue&type=template&id=5afe0675&scoped=true"
import script from "./Countdown.vue?vue&type=script&lang=js"
export * from "./Countdown.vue?vue&type=script&lang=js"

import "./Countdown.vue?vue&type=style&index=0&id=5afe0675&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5afe0675"]])

export default __exports__